'use client'

import { Flag24 } from '@vinted/monochrome-icons'
import { Cell, Icon } from '@vinted/web-ui'
import { v4 as uuid } from 'uuid'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { setSessionStorageItem } from '@marketplace-web/browser/browser-storage-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { clickEvent, messagingClickEvent } from '@marketplace-web/messaging/tracking-data'
import { NEW_ADMIN_ALERT_URL } from '@marketplace-web/messaging/navigation-feature'
import { REPORT_SESSION_ID_KEY, AlertType } from '@marketplace-web/admin-alert/admin-alert-data'

type Props = {
  conversationId: number | string
  userSide?: string
}

const MemberReportAction = ({ userSide, conversationId }: Props) => {
  const translate = useTranslate()
  const { track } = useTracking()
  const { relativeUrl } = useBrowserNavigation()

  const handleReportClick = () => {
    setSessionStorageItem(REPORT_SESSION_ID_KEY, uuid())

    track(
      clickEvent({
        screen: 'message_list',
        target: 'report_conversation',
        targetDetails: String(conversationId),
      }),
    )

    track(
      messagingClickEvent({
        userSide,
        screen: 'conversation_details',
        target: 'report_conversation',
        conversationId: String(conversationId),
      }),
    )
  }

  const reportUrl = urlWithParams(NEW_ADMIN_ALERT_URL, {
    ref_id: conversationId,
    ref_type: AlertType.Conversation,
    ref_url: relativeUrl,
  })

  return (
    <Cell
      title={translate('conversation.conversation_info.conversation_actions.report')}
      prefix={<Icon name={Flag24} color="warning-default" />}
      type="navigating"
      url={reportUrl}
      onClick={handleReportClick}
      testId="conversation-actions-report"
    />
  )
}

export default MemberReportAction
